'use client';
import styles from './styles.module.scss';
import { useState } from 'react';
import { Checkbox } from 'pretty-checkbox-react';

const DemoForm = (props) => {
    const { colorScheme } = props || {};

    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState(false);
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        company: '',
        checkboxes: {
            memberManagement: false,
            programLeagueManagement: false,
            financeManagement: false,
            childCare: false,
            marketingEngagement: false,
            facilityManagement: false,
            ymca: false,
            jcc: false,
            boysAndGirlsClub: false,
            communityCenter: false,
            parksAndRecreation: false,
            other: false,
        }
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === 'checkbox') {
            setFormData({
                ...formData,
                checkboxes: {
                    ...formData.checkboxes,
                    [name]: checked,
                },
            });
        } else {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(false);

        try {
            const response = await fetch('/api/demo_form', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (!response.ok) {
                throw new Error('Failed to submit form');
            }

            const data = await response.json();
            setFormData({
                firstName: '',
                lastName: '',
                phone: '',
                email: '',
                company: '',
                checkboxes: {
                    memberManagement: false,
                    programLeagueManagement: false,
                    financeManagement: false,
                    childCare: false,
                    marketingEngagement: false,
                    facilityManagement: false,
                    ymca: false,
                    jcc: false,
                    boysAndGirlsClub: false,
                    communityCenter: false,
                    parksAndRecreation: false,
                    other: false,
                }
            });
            setLoading(false);
            setError(false);
            setSubmitted(true);
        } catch (error) {
            setLoading(false);
            setError(true);
            setSubmitted(false);
        }
    };

    const renderError = () => {
        if (!error) return null;
        return (
            <div className={`${styles.demoForm__error} form_error_message`}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M8.00004 1.33334C4.32004 1.33334 1.33337 4.32001 1.33337 8.00001C1.33337 11.68 4.32004 14.6667 8.00004 14.6667C11.68 14.6667 14.6667 11.68 14.6667 8.00001C14.6667 4.32001 11.68 1.33334 8.00004 1.33334ZM7.33337 11.3333V10H8.66671V11.3333H7.33337ZM7.33337 4.66668V8.66668H8.66671V4.66668H7.33337Z" fill="#E8236B"/>
                </svg>
                <span>There was an error with your form submission</span>
            </div>
        );
    };

    const renderCtaOrSuccessMessage = () => {
        if (!submitted) {
            return (
                <div className={styles.demoForm__ctaRow}>
                    <button disabled={loading} className={`${styles.callout__cta} button large ${colorScheme}`}>
                        Schedule My Demo
                    </button>
                </div>
            );
        } else {
            return (
                <div className={styles.demoForm__ctaRow}>
                    <div className={styles.demoForm__success}>
                        You have Successfully Submitted Your Request
                    </div>
                </div>
            );
        }
    };

    return (
        <div className={styles.demoForm} onSubmit={handleSubmit}>
            <div className="container">
                <form className={styles.demoForm__form}>
                    {renderError()}
                    <div className={styles.demoForm__checkList}>
                        <label className={styles.demoForm__label}>Select all that apply:</label>
                        <Checkbox name="memberManagement" checked={formData.checkboxes.memberManagement} onChange={handleChange}>
                            Member Management
                        </Checkbox>
                        <Checkbox name="programLeagueManagement" checked={formData.checkboxes.programLeagueManagement} onChange={handleChange}>
                            Program & League Management
                        </Checkbox>
                        <Checkbox name="financeManagement" checked={formData.checkboxes.financeManagement} onChange={handleChange}>
                            Finance Management & Fundraising
                        </Checkbox>
                        <Checkbox name="childCare" checked={formData.checkboxes.childCare} onChange={handleChange}>
                            Child Care
                        </Checkbox>
                        <Checkbox name="marketingEngagement" checked={formData.checkboxes.marketingEngagement} onChange={handleChange}>
                            Marketing & Engagement
                        </Checkbox>
                        <Checkbox name="facilityManagement" checked={formData.checkboxes.facilityManagement} onChange={handleChange}>
                            Facility Management & Access
                        </Checkbox>
                    </div>
                    <div>
                        <fieldset className="fieldset">
                            <label className="label">First Name</label>
                            <input type="text" name="firstName" className={`input ${error ? 'input_error' : ''}`} onChange={handleChange} required />
                        </fieldset>
                        <fieldset className="fieldset">
                            <label className="label">Email</label>
                            <input type="email" name="email" className={`input ${error ? 'input_error' : ''}`} onChange={handleChange} required />
                        </fieldset>
                    </div>
                    <div>
                        <fieldset className="fieldset">
                            <label className="label">Last Name</label>
                            <input type="text" name="lastName" className={`input ${error ? 'input_error' : ''}`} onChange={handleChange} required />
                        </fieldset>
                        <fieldset className="fieldset">
                            <label className="label">Phone</label>
                            <input type="tel" name="phone" className={`input ${error ? 'input_error' : ''}`} onChange={handleChange} required />
                        </fieldset>
                    </div>
                    <div>
                        <fieldset className="fieldset">
                            <label className="label">Organization</label>
                            <input type="tel" name="company" className={`input ${error ? 'input_error' : ''}`} onChange={handleChange} required />
                        </fieldset>
                    </div>
                    <div className={styles.demoForm__checkList}>
                        <label className={styles.demoForm__label}>I Am Representing:</label>
                        <Checkbox name="ymca" checked={formData.checkboxes.ymca} onChange={handleChange}>
                            YMCA
                        </Checkbox>
                        <Checkbox name="jcc" checked={formData.checkboxes.jcc} onChange={handleChange}>
                            JCC
                        </Checkbox>
                        <Checkbox name="boysAndGirlsClub" checked={formData.checkboxes.boysAndGirlsClub} onChange={handleChange}>
                            Boys and Girls Club
                        </Checkbox>
                        <Checkbox name="communityCenter" checked={formData.checkboxes.communityCenter} onChange={handleChange}>
                            Community Center
                        </Checkbox>
                        <Checkbox name="parksAndRecreation" checked={formData.checkboxes.parksAndRecreation} onChange={handleChange}>
                            Parks and Recreation
                        </Checkbox>
                        <Checkbox name="other" checked={formData.checkboxes.other} onChange={handleChange}>
                            Other
                        </Checkbox>
                    </div>
                    <fieldset className={`fieldset ${styles.demoForm__textBox}`}>
                        <label className="label">Would you like to tell us anything specific about your needs?</label>
                        <textarea type="text" name="additionalInfo" className={`${error ? 'input_error' : ''}`} onChange={handleChange}></textarea>
                    </fieldset>
                    {renderCtaOrSuccessMessage()}
                </form>
            </div>
        </div>
    );
};

export default DemoForm;
